import React from 'react'
import Django from '../assests/port/Django.png'
import react from '../assests/port/react.png'
import jira from '../assests/port/jira.png'
import flask from '../assests/port/flask.jpg'
import tailwind from '../assests/port/tailwind.png'
import Python  from '../assests/port/Python.png'
import javascript  from '../assests/port/javascript.png'
import github from '../assests/port/github.png'
import figma from '../assests/port/figma.jpg'

const Experience = () => {

    
const data = [
    {
     id:1,
     src:Django,
     title:"Django",
     style:"shadow-green-500"
    },
    {
        id:2,
        src:flask,
        title:"Flask",
        style:"shadow-green-600"
       },
       {
        id:3,
        src:jira,
        title:"Jira",
        style:"shadow-blue-500"
       },
       {
        id:4,
        src:react,
        title:"React",
        style:"shadow-blue-600"
       },
       {
        id:5,
        src:javascript,
        title:"Javascript",
        style:"shadow-yellow-500"
       },
       {
        id:6,
        src:tailwind,
        title:"Tailwind",
        style:"shadow-sky-400"
       },
       {
        id:7,
        src:Python,
        title:"Python",
        style:"shadow-blue-500"
       },
       {
        id:8,
        src:github,
        title:"Github",
        style:"shadow-gray-500"
       },
       {
        id:9,
        src:figma,
        title:"Figma",
        style:"shadow-orange-400"
       }
    
]
  return (
   <div name="experience" className='bg-gradient-to-b from-gray-800 to-black w-full h-screen'>
    <div className='max-w-screen-lg mx-auto  p-4 flex flex-col justify-center w-full h-full text-white'>
        <div>
            <p className='text-4xl font-bold border-b-4 border-gray-500 p-2 inline'>Experience</p>
            <p className='py-6'>These are the technologies I've worked with</p>
        </div>

        <div>
            <div className='w-full grid grid-cols-2   sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0'>

              {

                data.map(({id,src,title,style})=>(

        <div key={id} className={`shadow-md hover:scale-105  duration-500 py-2 rounded-lg ${style}`}>
                <img src={src} alt='' className='w-20 mx-auto' />
                 <p className='mt-4'>{title}</p>
                </div>

                ))
              }

                
            </div>
        </div>
    </div>
   </div>
)
}

export default Experience